<template>
  <div class="pcm-a-wrapper" id="pcm-wrapper">
    <!-- 背景（已抠掉标题与人物轮播，只保留纯背景层） -->
    <img class="pcm-a-bg" src="@/assets/images/pc/pageA/bg.webp" alt="" />

    <!-- 人物轮播：改用 FlowCarousel 组件（原来是 VP9+alpha 视频，
         Safari 不合成 alpha 只能退化成首帧图，且要靠手势兜底起播） -->
    <FlowCarousel class="pcm-a-carousel" :items="carouselItems" />

    <!-- 标题 -->
    <img
      class="pcm-a-title"
      src="@/assets/images/pc/pageA/title.gif"
      alt="黄果免费看 · AI成人短剧全面上线"
    />

    <!-- 顶部导航 -->
    <div class="pcm-a-nav">
      <div class="pcm-a-brand">
        <img
          class="pcm-a-brand-icon"
          src="@/assets/images/mobile1/pageA/logo-icon.webp"
          alt=""
        />
        <img
          class="pcm-a-brand-text"
          src="@/assets/images/mobile1/pageA/logo-text.webp"
          alt="黄果免费看"
        />
      </div>
      <div class="pcm-a-services">
        <div v-if="swUrl" class="pcm-a-service" @click="toContact(swUrl)">
          <img
            class="pcm-a-service-icon"
            src="@/assets/images/pc/pageA/icon-sw.svg"
            alt=""
          />
          <span class="pcm-a-service-text">商务合作</span>
        </div>
        <div v-if="qdUrl" class="pcm-a-service" @click="toContact(qdUrl)">
          <img
            class="pcm-a-service-icon"
            src="@/assets/images/pc/pageA/icon-qd.svg"
            alt=""
          />
          <span class="pcm-a-service-text">渠道合作</span>
        </div>
        <div v-if="tgUrl" class="pcm-a-service" @click="toContact(tgUrl)">
          <img
            class="pcm-a-service-icon"
            src="@/assets/images/pc/pageA/icon-tg.svg"
            alt=""
          />
          <span class="pcm-a-service-text">官方群组</span>
        </div>
      </div>
    </div>

    <!-- 二维码 -->
    <div class="pcm-a-qr-panel">
      <img class="pcm-a-qr" :src="qrImg" alt="下载二维码" />
      <div class="pcm-a-qr-tip">推荐使用UC浏览器下载</div>
    </div>

    <!-- 马上开看 -->
    <img
      class="pcm-a-open"
      src="@/assets/images/mobile1/pageA/btn-open.webp"
      alt="马上开看"
    />

    <!-- 安装提示 -->
    <div class="pcm-a-install-tip">
      <p>安装提示：</p>
      <p>由于APP包含成人内容，可能会被某些</p>
      <p>杀毒软件定为病毒，请大家放心下载使用。</p>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";
import FlowCarousel from "@/components/FlowCarousel";
import { carouselItems } from "@/constants/carouselItems";

export default {
  components: { FlowCarousel },
  props: ["qrImg", "configs", "version"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      carouselItems
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-wrapper",
        resize: true
      },
      false
    );
  },
  methods: {
    toContact(url) {
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-a-wrapper {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: #060606;

  .pcm-a-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 1920px;
    height: 1080px;
    z-index: 0;
    pointer-events: none;
  }

  /* 人物轮播：912x661 正好是组件 1200x870 设计稿的 0.76 倍，
     组件按容器宽度自适应，高度会自己算出 661 */
  .pcm-a-carousel {
    position: absolute;
    left: 980px;
    top: 211px;
    width: 912px;
    z-index: 1;
  }

  /* 标题 */
  .pcm-a-title {
    position: absolute;
    left: 213.8px;
    top: 164.6px;
    width: 787.5px;
    height: 315px;
    z-index: 2;
    pointer-events: none;
  }

  /* 顶部导航 */
  .pcm-a-nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 1920px;
    height: 90px;
    box-sizing: border-box;
    padding: 0 206px;
    background: rgba(10, 10, 10, 0.8);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
  }

  .pcm-a-brand {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .pcm-a-brand-icon {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    box-shadow: 0 0.469px 0.469px rgba(0, 0, 0, 0.25);
  }

  .pcm-a-brand-text {
    width: 135px;
    height: 63px;
  }

  .pcm-a-services {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .pcm-a-service {
    position: relative;
    width: 160px;
    height: 50px;
    box-sizing: border-box;
    border: 1.5px solid #ffe59e;
    border-radius: 36px;
    background: linear-gradient(90deg, #ffe59e 0%, #d4a853 50%, #8f6623 100%);
    box-shadow: 0 6px 18px rgba(204, 34, 51, 0.13);
    cursor: pointer;
  }

  .pcm-a-service-icon {
    position: absolute;
    left: 20px;
    top: 9px;
    width: 32px;
    height: 32px;
  }

  .pcm-a-service-text {
    position: absolute;
    left: 60px;
    top: 13px;
    height: 24px;
    line-height: 24px;
    font-size: 20px;
    font-family: -apple-system, "PingFang SC", "Helvetica Neue",
      "Microsoft YaHei", sans-serif;
    font-weight: 500;
    color: #0a0a0a;
    white-space: nowrap;
  }

  /* 二维码 */
  .pcm-a-qr-panel {
    position: absolute;
    left: 299px;
    top: 700px;
    width: 220.008px;
    height: 249.263px;
    box-sizing: border-box;
    background: #1d1d1d;
    border: 1.528px solid #ffe59e;
    border-radius: 8.686px;
    z-index: 5;

    .pcm-a-qr {
      position: absolute;
      left: 16.043px;
      top: 15.279px;
      width: 187.943px;
      height: 187.943px;
      background: #fff;
    }

    .pcm-a-qr-tip {
      position: absolute;
      left: 11.923px;
      top: 212.416px;
      width: 196.295px;
      height: 23.755px;
      line-height: 23.755px;
      font-size: 17.372px;
      font-family: -apple-system, "PingFang SC", "Helvetica Neue",
        "Microsoft YaHei", sans-serif;
      font-weight: 600;
      letter-spacing: 1.39px;
      color: #fad378;
      text-align: center;
      white-space: nowrap;
    }
  }

  /* 马上开看 */
  .pcm-a-open {
    position: absolute;
    left: 551px;
    top: 721px;
    width: 350px;
    height: 104px;
    z-index: 5;
    pointer-events: none;
  }

  /* 安装提示 */
  .pcm-a-install-tip {
    position: absolute;
    left: 559px;
    top: 857px;
    width: 452px;
    z-index: 5;
    font-size: 23.747px;
    font-family: -apple-system, "PingFang SC", "Helvetica Neue",
      "Microsoft YaHei", sans-serif;
    font-weight: 400;
    line-height: 29px;
    color: #fff;
    white-space: nowrap;

    p {
      margin: 0;
    }
  }
}
</style>
